import { translate } from 'hooks/useTranslate';
import { Council, Society, User } from 'types';
import createDocumentFromHtml from 'utils/createDocumentFromHtml';

type SaveCouncilAnnouncementProps = {
  user: User;
  society: Society;
  council: Council;
  announcementTemplate: any;
};

export const saveCouncilAnnouncement = async ({
  user,
  society,
  council,
  announcementTemplate,
}: SaveCouncilAnnouncementProps): Promise<string> => {
  const announcementDocName = `${translate('AnnouncementCouncil')}`;
  const announcementDocDescription = `${translate(
    'GeneratedByTheTemplate'
  )} ${translate('AnnouncementTemplate')}_${council.name}`;

  const documentId = await createDocumentFromHtml({
    html: announcementTemplate.editorModel,
    tagsData: { society, council },
    documentName: announcementDocName,
    documentDescription: announcementDocDescription,
    society,
    user,
  });

  return documentId;
};
